/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./dialog-holder.component";
var styles_DialogHolderComponent = [];
var RenderType_DialogHolderComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_DialogHolderComponent, data: {} });
export { RenderType_DialogHolderComponent as RenderType_DialogHolderComponent };
export function View_DialogHolderComponent_0(_l) { return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { element: 0 }), (_l()(), i0.ɵeld(1, 16777216, [[1, 3], ["element", 1]], null, 0, "template", [], null, null, null, null, null))], null, null); }
export function View_DialogHolderComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "dialog-holder", [], null, null, null, View_DialogHolderComponent_0, RenderType_DialogHolderComponent)), i0.ɵdid(1, 49152, null, 0, i1.DialogHolderComponent, [i0.ComponentFactoryResolver], null, null)], null, null); }
var DialogHolderComponentNgFactory = i0.ɵccf("dialog-holder", i1.DialogHolderComponent, View_DialogHolderComponent_Host_0, {}, {}, []);
export { DialogHolderComponentNgFactory as DialogHolderComponentNgFactory };
